module.exports = __webpack_public_path__ + "static-portal/media/yy.34a9913.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy.mp3
// module id = Upr4
// module chunks = 4